// Clinic Configuration for Dentist in Oregon
// This file contains all clinic-specific values used across the application

export const CLINIC_CONFIG = {
  // Basic Information
  clinicName: "Dentist in Oregon",
  clinicId: "dentistinoregonoh",
  clinicUrl: "https://dentistinoregonoh.com",
  aiAgent: "wss://ws.todaysdentalinsights.com/ai-agents?clinicId=dentistinoregonoh&agentId=60310193-e87a-41b1-9b30-34b9fc23b3b0",
  voiceApiUrl: "https://apig.todaysdentalinsights.com/ai-agents/public/clinic/dentistinoregonoh/voice",

  // Contact Information
  phoneNumber: "419-690-0320",
  phoneNumberRaw: "+14196900320", // For tel: and sms: links
  email: "dentalcare@dentistinoregonoh.com",

  // Location
  address: "3555 Navarre Ave #12, Oregon, OH 43616, United States",
  addressShort: "3555 Navarre Ave #12, Oregon, OH 43616",
  city: "Oregon",
  hcity: "Oregon",
  state: "Ohio",
  stateShortForm: "OH",
  PostalCode: "43616",

  // Map Links
  mapUrl: "https://maps.app.goo.gl/vdXR35WnGCrZTf7T8",

  // Embedded Map
  iframe: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2981.80114196368!2d-83.4625817!3d41.6384296!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x883b8509da361c09%3A0xef041a9d3d69e118!2sDentist%20in%20Oregon%20LLC!5e0!3m2!1sen!2sin!4v1756792463012!5m2!1sen!2sin',

  iframeTitle: "Dentist in Oregon",

  //membership
  membership: "https://member.kleer.com/?slug=JZ3M",

  // Sunbit
  sunbitUrl: "https://apply.sunbit.com/DentistinOregon",

  // Cherry
  cherryUrl: "https://pay.withcherry.com/dentist-in-oregon?utm_source=practice&utm_medium=email&m=65974",


  // Analytics
  clarityProjectId: "prdbm63nqu",

  // API Configuration
  apiBaseUrl: "https://apig.todaysdentalinsights.com/patientportal/dentistinoregonoh",
  callbackUrl: "https://apig.todaysdentalinsights.com/callback/dentistinoregonoh",
  clinicHoursUrl: "https://apig.todaysdentalinsights.com/clinic-hours/hours/dentistinoregonoh",
  websocketUrl: "wss://ws.todaysdentalinsights.com/chat",
  webAssistantUrl: "https://dentistinoregonoh.web-assistant.tensorlinks.app/",

  // Social Media Links
  social: {
    facebook: "https://www.facebook.com/people/Dentist-in-Oregon/61560541544320/",
    instagram: "https://www.instagram.com/stories/dentistinoregon/",
    twitter: "https://x.com/Dentist_Oregon",
    linkedin: "https://www.linkedin.com/authwall?trk=bf&trkInfo=AQGiKzrW_4o25AAAAZm-VTvo5KN-5eVTITBSx__hSWqf2-kQySIl0ig8J4295FFnMnG1BHM4BMvbvbVjcLNnt0dJfn6eBE0w9Tst85ECBY1_S3Gn8REImlPuPcGWvEZQ8xtVcUw=&original_referer=&sessionRedirect=https%3A%2F%2Fwww.linkedin.com%2Fcompany%2F108118827%2Fadmin%2F%3Flipi%3Durn%253Ali%253Apage%253Ad_flagship3_feed%253BZHzZHS4UQLaEyel%252BGoze8g%253D%253D",
    youtube: "https://www.youtube.com/@DentistinOregonOH",
  },

  // Open Dental Configuration
  defaultProvNum: 6,
  defaultOpNum: 21,

  // Appointment Types Configuration
  appointmentTypes: [
    {
      value: "New patient emergency/other",
      label: "New patient emergency/other",
      duration: 30,
      opNum: 23,
      AppointmentTypeNum: 2,
    },
    {
      value: "Existing patient emergency/other",
      label: "Existing patient emergency/other",
      duration: 30,
      opNum: 11, // DEFAULT_OP_NUM
      AppointmentTypeNum: 10,
    },
    {
      value: "Existing patient current treatment Plan",
      label: "Existing patient current treatment Plan",
      duration: 30,
      opNum: 11, // DEFAULT_OP_NUM
      AppointmentTypeNum: 6,
    },
  ],

  // Helper functions for common patterns
  getTelLink: function () {
    return `tel:${this.phoneNumberRaw}`;
  },

  getSmsLink: function (body?: string) {
    const bodyText = body || "Hello%20";
    return `sms:${this.phoneNumberRaw}?body=${bodyText}`;
  },

  getEmailLink: function (subject?: string, body?: string) {
    const params = [];
    if (subject) params.push(`subject=${encodeURIComponent(subject)}`);
    if (body) params.push(`body=${encodeURIComponent(body)}`);
    const queryString = params.length > 0 ? `?${params.join('&')}` : '';
    return `mailto:${this.email}${queryString}`;
  },
};

// Export individual items for convenience
export const {
  clinicName,
  clinicId,
  phoneNumber,
  phoneNumberRaw,
  email,
  address,
  addressShort,
  city,
  state,
  stateShortForm,
  mapUrl,
  iframe,
  iframeTitle,
  clarityProjectId,
  apiBaseUrl,
  callbackUrl,
  clinicHoursUrl,
  websocketUrl,
  social,
  defaultProvNum,
  defaultOpNum,
  appointmentTypes,
} = CLINIC_CONFIG;

export default CLINIC_CONFIG;
